module.exports = __webpack_public_path__ + "img/instruction-simulated.988d520b.png";